import(/* webpackMode: "eager", webpackExports: ["JudgeCatalogClient"] */ "/vercel/path0/features/judge/components/JudgeCatalogClient.tsx");
